import { baseTableConfig } from "~/utils/tables";
export default {
    ...baseTableConfig,
    items: [],
    fields: [
        {
            key: "id",
            label: "#",
            fixed: true,
            sorter: false,
            filter: false,
            _filter: false,
            _style: "width:5%",
            _active: true,
        },
        {
            key: "email",
            label: "email",
            sorter: false,
            filter: true,
            _filter: true,
            _active: true,
            _style: "width:30%",
        },
        {
            key: "reason",
            label: "reason",
            active: true,
            sorter: false,
            filter: true,
            _filter: true,
        },
        {
            key: "created_at",
            label: "created_at",
            active: true,
            sorter: false,
            filter: false,
            _filter: false,
            _style: "width:10%",
        },
    ]
}